import { render } from "./UnitView.vue?vue&type=template&id=34959b5f"
import script from "./UnitView.vue?vue&type=script&lang=js"
export * from "./UnitView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__